import { Controller, Toolbar, Menu } from '@tencent/workbench';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { SearchReplaceFeature } from './search-replace-feature';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';
import appConfigInstance, { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

/**
 * 格式刷
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class SearchReplaceController {
    public constructor(private readonly feature: SearchReplaceFeature) {}

    @Toolbar(config.id, 'onClick')
    @Menu(config.id, 'onClick')
    public onClick() {
        this.feature.callback();
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_PLAY, 'shouldHide')
    public shouldDoubleToolPlayHide() {
        return !!this.feature.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType;
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_ANIM, 'shouldHide')
    public shouldDoubleToolAnimHide() {
        return !!this.feature.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType;
    }

    // ssv的场景下需屏蔽会员功能
    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_EFFICIENCY, 'shouldHide')
    public shouldDoubleToolEfficiencyHide() {
        return !!this.feature.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType
        || !(appConfigInstance.getConfig(ToolbarFileMenuConfig.toolbarEfficiency as any) ?? true);
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_COMMENT, 'shouldHide')
    public shouldDoubleToolCommentHide() {
        return !!this.feature.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType
        || !getCacConfigByKey('feature.comment', false);
    }

    @Menu('toolbar-efficiency-parent', 'shouldHide')
    public shouldMenuEfficiencyHide() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.toolbarEfficiency as any) ?? true);
    }
}
